unable to read source [project]/packages/core/src/devtools/getAtomicDebugSequenceTree.ts